/**
  文字轮播展示接收参数：
  params: {
    width: 宽度，
    color: 颜色
    marqueetext： 文本
  }
 */

<template>
  <div class="marquee-wrap" :style="{'width':width}">
    <div ref="mqBox" class="marquee-box">
      <div ref="mqText" :style="{'color': color}">{{marqueetext}}</div>
      <div :style="{'color': color}">{{marqueetext}}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Marquee",
  props: ["marqueetext", "width", "color"],
  data() {
    return {
      marqueeTime: false
    };
  },
  methods: {
    move() {
      let mqBox = this.$refs.mqBox;
      let mqText = this.$refs.mqText;
      let distance = 0; // 位移距离

      this.marqueeTime = setInterval(() => {
        distance--;
        if (-distance >= mqText.getBoundingClientRect().width) {
          distance = 30;
        }
        mqBox.style.transform = "translateX(" + distance + "px)";
      }, 20);
    }
  },
  // 更新的时候运动
  mounted: function() {
    clearInterval(this.marqueeTime);
    this.move();
  },
  beforeDestroy() {
    clearInterval(this.marqueeTime);
  }
};
</script>
<style lang="less" scoped>
.marquee-wrap {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  margin: auto;
  font-size: 14px;
  color: #fff;

  .marquee-box {
    width: 80000%;
    height: 100%;

    & > div {
      float: left;
      margin-right: 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/marquee.vue